function idsInSameOrder<T extends Record<string, any>>(
  a: T[],
  b: T[],
  key: string
) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i]?.[key] !== b[i]?.[key]) return false;
  }
  return true;
}

export { idsInSameOrder };
